import React, { useCallback, useEffect, useState } from 'react'
import { getOperationList } from '../utils/network'
import useList from 'hooks/useList'
import { formatOperationList } from '../utils/formatOperationList'
import showOperationDialog from '../utils/showOperationDialog'
import Button from '@tencent/spaui-button'
import { PopOver, OverlayTrigger } from '@tencent/spaui-popover'
import { Icon } from '@tencent/spaui'
import { ALLOWED_REPLACE_STATUS, OPERATION_DIALOG, REJECTED_STATUS } from '../constants'

const useOperationList = (appInfo = {}) => {
    const genUpdateDataAPIParams = params => {
        const req = {}
        req[params.searchName] = params.filterText
        req.appid = appInfo.appId
        return req
    }
    const genUpdateDataAPIParamsMemo = useCallback(genUpdateDataAPIParams, [appInfo.appId])
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight - 300)
    useEffect(() => {
        window.addEventListener('resize', () => {
            setBodyHeight(document.body.clientHeight - 300)
        })
    }, [])

    const { state, setState } = useList({
        updateDataAPI: getOperationList,
        genUpdateDataAPIParams: genUpdateDataAPIParamsMemo,
        derivedData: null,
        dataFormatter: formatOperationList,
        filterSelectValue: -1,
        searchName: 'uid',
    })

    const showReplaceDialogHandler = (row, e) => {
        e.preventDefault()
        showOperationDialog(OPERATION_DIALOG.REPLACE, { appInfo, ...setState, ...row })
    }

    const showBindDialogHandler = e => {
        e.preventDefault()
        showOperationDialog(OPERATION_DIALOG.BIND, { appInfo, ...setState })
    }

    const colRender = (type, rowName, value, rowData) => {
        if (type !== 'head') {
            if (rowName === 'operate') {
                if (ALLOWED_REPLACE_STATUS.includes(rowData.actionType)) {
                    return (
                        <div className="a-table-action channel-package-table-action">
                            <a href="void:0" onClick={e => showReplaceDialogHandler(rowData, e)}>
                                换绑
                            </a>
                        </div>
                    )
                }
            }
            if (rowName === 'status') {
                if (REJECTED_STATUS.includes(rowData.actionType)) {
                    return (
                        <OverlayTrigger trigger="hover" overlay={<PopOver>{rowData.rejectReason}</PopOver>}>
                            <span>
                                {value}
                                <Icon
                                    name="exclamation-filled"
                                    width="14"
                                    height="14"
                                    style={{
                                        position: 'relative',
                                        top: '2px',
                                        marginLeft: '5px',
                                    }}
                                />
                            </span>
                        </OverlayTrigger>
                    )
                }
            }
            if (rowName === 'uid') {
                return <span>{rowData.uidInfo.uid}</span>
            }
        }

        return value
    }

    const HeaderRightAddOn = () => {
        return (
            <div className="toolbar-right-group">
                <Button className="borderless" onClick={showBindDialogHandler}>
                    <i className="icon icon-group-upload"></i>添加
                </Button>
            </div>
        )
    }

    return {
        state,
        setState,
        colRender,
        HeaderRightAddOn,
        genUpdateDataAPIParams,
        bodyHeight,
    }
}

export default useOperationList
